import type { GetContractBillingScheduleReportResponse } from '@weft/api-definition';
import { GetContractBillingScheduleReportResponseSchema } from '@weft/api-definition';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';

export function useContractBillingScheduleReport(contractId: string, options?: CustomUseQueryOptions<GetContractBillingScheduleReportResponse>) {
  return useQuery({
    queryKey: ['contract-billing-schedule-report'],
    queryFn: async () => {
      const api = getPrivateApi();

      const response = await api.getContractBillingScheduleReport({ contractId });

      return GetContractBillingScheduleReportResponseSchema.parse(response);
    },
    ...options,
  });
}